export default function Features() {
  const features = [
    {
      icon: 'ri-stethoscope-line',
      title: '歯科医師による電話診療',
      description: '経験豊富な歯科医師が、歯の状態を写真で確認後、丁寧に診察。安心して施術を始められます。オンラインで完結するため、ご来店の手間がありません。'
    },
    {
      icon: 'ri-flask-line',
      title: '医療用成分配合',
      description: '市販品では使用できない医療用の過酸化水素が配合された医療用ホワイトニングシートを採用。本格的なホワイトニング効果を実感できます。'
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全性と効果の両立',
      description: '歯科医師監修のもと厳格な品質管理で製造。効果的でありながら、歯や歯茎への負担を最小限に抑えた処方設計となっています。'
    }
  ];

  return (
    <section id="features" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="w-16 h-1 bg-[#4A90E2] mx-auto mb-6"></div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">選ばれる3つの理由</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-white border border-gray-100 rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 shadow-sm hover:shadow-xl cursor-pointer"
            >
              <div className="w-20 h-20 bg-[#E3F2FD] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${feature.icon} text-3xl text-[#2C5AA0]`}></i>
              </div>
              
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">{feature.title}</h3>
              
              <p className="text-sm text-gray-600 leading-relaxed text-center mb-0">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}